import React from 'react'
import { Link } from 'react-router-dom'

const Box = (props) => {
  return (
    <>
      {!props.outLink ? (
        <Link
          to={props.link}
          className={`profile-link-box wow ${props.animate}`}
        >
          <div>{props.icon}</div>
          <div className='title'>{props.title}</div>
          <div>
            {props.linkNotficate ? (
              <Link to={props.linkNotficate} className='linkNotficate'>
                {props.notficate}
              </Link>
            ) : (
              props.notficate
            )}
          </div>
        </Link>
      ) : (
        <span
          onClick={() => (window.location.href = props.link)}
          className={`profile-link-box wow ${props.animate}`}
        >
          <div>{props.icon}</div>
          <div className='title'>{props.title}</div>
          <div>
            {props.linkNotficate ? (
              <Link to={props.linkNotficate} className='linkNotficate'>
                {props.notficate}
              </Link>
            ) : (
              props.notficate
            )}
          </div>
        </span>
      )}
    </>
  )
}
export default Box
